export default "__VITE_PUBLIC_ASSET__a21c1d54__"